export const state = () => ({
  userTypes: [],
  currentUserType: null,
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  userTypes: (state) => state.userTypes,
  currentUserType: (state) => state.currentUserType,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_USER_TYPES(state, data) {
    if (data.content) {
      state.userTypes = data.content
      state.pagination = {
        page: data.number,
        size: data.size,
        totalElements: data.totalElements,
        totalPages: data.totalPages
      }
    } else {
      state.userTypes = Array.isArray(data) ? data : []
    }
  },
  SET_CURRENT_USER_TYPE(state, userType) {
    state.currentUserType = userType
  },
  ADD_USER_TYPE(state, userType) {
    state.userTypes.push(userType)
  },
  UPDATE_USER_TYPE(state, userType) {
    const index = state.userTypes.findIndex(ut => ut.id === userType.id)
    if (index !== -1) {
      state.userTypes.splice(index, 1, userType)
    }
  },
  REMOVE_USER_TYPE(state, userTypeId) {
    state.userTypes = state.userTypes.filter(ut => ut.id !== userTypeId)
  }
}

export const actions = {
  async fetchUserTypes({ commit }, { page = 0, size = 10, sortBy = 'code', direction = 'asc' } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get('/auth/api/user-types', {
        params: { page, size, sortBy, direction }
      })
      commit('SET_USER_TYPES', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch user types')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchUserType({ commit }, userTypeId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/user-types/${userTypeId}`)
      commit('SET_CURRENT_USER_TYPE', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch user type')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createUserType({ commit }, userTypeData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/user-types', userTypeData)
      commit('ADD_USER_TYPE', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to create user type')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteUserType({ commit }, userTypeId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete(`/auth/api/user-types/${userTypeId}`)
      commit('REMOVE_USER_TYPE', userTypeId)
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to delete user type')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

